import aiGenerationStatuses from '../../../constants/aiGenerationStatuses';
import SUMMARY_TIMEOUT_MS from '../../../constants/summaryTimeout';
import { CaseSummary } from '../../../utilities/schemas/case';

const isSummaryTimedOut = (startedAt: string | undefined): boolean => {
  if (!startedAt) return true;
  return Date.now() - new Date(startedAt).getTime() > SUMMARY_TIMEOUT_MS;
};

const getCaseDescriptionText = (caseSummary: CaseSummary | undefined) => {
  const {
    shortDescription,
    aiSummaryStatus,
    startedAt,
  } = caseSummary ?? {};

  if (!aiSummaryStatus) {
    return {
      text: '-',
      isPending: false,
      hasError: false,
      shouldShowSummary: false,
    };
  }

  if (aiSummaryStatus === aiGenerationStatuses.CREATED) {
    if (isSummaryTimedOut(startedAt)) {
      return {
        text: 'Error generating AI summary',
        isPending: false,
        hasError: true,
        shouldShowSummary: true,
      };
    }

    return {
      text: 'Generating',
      isPending: true,
      hasError: false,
      shouldShowSummary: true,
    };
  }

  if (aiSummaryStatus === aiGenerationStatuses.ERROR || !shortDescription) {
    return {
      text: 'Error generating AI summary',
      isPending: false,
      hasError: true,
      shouldShowSummary: true,
    };
  }

  if (aiSummaryStatus === aiGenerationStatuses.COMPLETE) {
    return {
      text: shortDescription,
      isPending: false,
      hasError: false,
      shouldShowSummary: true,
    };
  }

  aiSummaryStatus satisfies never;

  return {
    text: '-',
    isPending: false,
    hasError: false,
    shouldShowSummary: false,
  };
};

export default getCaseDescriptionText;
